import React, {
  PropsWithChildren,
  ClassAttributes,
  HTMLAttributes,
} from 'react';

export const H2 = (
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLHeadingElement> &
    HTMLAttributes<HTMLHeadingElement> &
    PropsWithChildren,
) => <h2 {...props} />;
